/**
 * Enum for Survey Question Type values.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export enum SurveyQuestionType {
    MULTIPLE_CHOICE = <any>'Multiple choice',
    PARAGRAPH_TEXT = <any>'Paragraph text',
    ENTITY_LOOKUP = <any>'Entity Lookup',
    IMAGE_QUESTION = <any>'Image Question'
}



// WEBPACK FOOTER //
// ./src/app/shared/models/survey/survey-question-type.enum.ts